import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { LargeProductSuitCardData } from '../types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { prismicImageLoader } from '@app/common/src/utils/prismicImageLoader'
import CTAButton from './CTAButton'
import Image from 'next/image'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import ValuePropsColumns from './ValuePropsColumns'

const LargeProductSuitCard: FC<{ data?: LargeProductSuitCardData }> = ({ data }) => {
  if (!data) return null

  const isCreateFlowcodeBtn = data.button_label?.toLowerCase() === 'create a flowcode'
  const isImageRightAligned = data.image_alignment === 'Right'

  return (
    <Box px="46px">
      <Box
        display="grid"
        gridTemplateAreas={'"l r"'}
        gridTemplateColumns={isImageRightAligned ? '45.1% 54.9%' : '54.9% 45.1%'}
        maxWidth="998px"
        mx="auto"
      >
        <Box gridArea={isImageRightAligned ? 'r' : 'l'}>
          {data.image?.url && (
            <Image
              src={data.image?.url}
              alt={data.image?.alt ?? ''}
              loader={prismicImageLoader}
              width={560}
              height={386}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          )}
        </Box>
        <Box
          flexDirection="column"
          maxWidth="486px"
          ml={isImageRightAligned ? 0 : '36px'}
          mr={isImageRightAligned ? '36px' : 0}
          justifyContent="center"
        >
          <Box flexDirection="column">
            {data['logo-title']?.url && (
              <Box flexDirection="column" textAlign="left" width="100%">
                <Image
                  src={data['logo-title']?.url}
                  alt={data['logo-title']?.alt ?? 'logo'}
                  loader={prismicImageLoader}
                  width={data['logo-title']?.dimensions?.width}
                  height={data['logo-title']?.dimensions?.height}
                  style={{ maxWidth: '153px', objectFit: 'contain' }}
                />
                <Spacer mb="16px" />
              </Box>
            )}
            <PrismicText richTextField={data.subheader} variant="display/large" lineHeight="40px" />
            <Spacer mb="16px" />
            <PrismicText richTextField={data.description} variant="body/large" />
            <ValuePropsColumns
              valuePropsText={data.value_props_list}
              valuePropsImages={data.value_props_images}
            />
            <Spacer mb="29px" />
            <Box>
              <CTAButton
                label={data.button_label}
                href={isCreateFlowcodeBtn ? undefined : data.button_href?.url}
                onClick={isCreateFlowcodeBtn ? () => window.scrollTo(0, 0) : undefined}
                variant={data.button_variant}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default LargeProductSuitCard
